export default [
  'touchstart',
  'touchend',
  'touchmove',
  'touchcancel',
  'mousedown',
  'mousemove',
  'mouseup',
  'click',
  'mouseenter',
]
